<main>
    <section class="section-form">
        <div class="container">
            <div class="row">
                <h1 class="text-center mb-4">Detalle de la compra</h1>
                <div class="col-md-12 col-lg-6 mt-5">
                    <form [formGroup]="formFacturacion" (ngSubmit)="onSubmit()">      
                        <h5 class="my-3">1.-Datos de facturación</h5>
    
                        <div class="row">
                            <div class="col-md-12 col-lg-6">
                                <div class="form-group mb-3">
                                    <label for="nombres">Nombres:</label>
                                    <input 
                                        type="text" 
                                        [formControlName]="'nombres'" 
                                        id="nombres" 
                                        [ngClass]="{'is-invalid':f['nombres'].errors && f['nombres'].touched, 'is-valid':!f['nombres'].errors && f['nombres'].touched}" 
                                        class="form-control" 
                                        placeholder="Ingrese sus nombres" 
                                        uppercase
                                        pattern="^[A-Za-záéíóúÁÉÍÓÚñÑ\s]*$"
                                        (input)="letterOnlyValidator($event)"
                                        required
                                    >
                                    <span *ngIf="f['nombres']?.errors?.['required']" class="invalid-feedback">
                                        Debe ingresar sus <strong>Nombre</strong>.
                                    </span>
                                    <span *ngIf="f['nombres'].errors?.['minlength'] || f['nombres'].errors?.['invalidName'] " class="invalid-feedback">
                                        Nombres <strong>no válido</strong>.
                                    </span>
                                </div>
                            </div>
    
                            <div class="col-md-12 col-lg-6">
                                <div class="form-group mb-3">
                                    <label for="apellidos">Apellidos:</label>
                                    <input 
                                        uppercase
                                        type="text" 
                                        [formControlName]="'apellidos'" 
                                        id="apellidos" 
                                        [ngClass]="{'is-invalid':f['apellidos'].errors && f['apellidos'].touched, 'is-valid':!f['apellidos'].errors && f['apellidos'].touched}" 
                                        class="form-control" 
                                        placeholder="Ingrese sus apellidos" 
                                        pattern="^[A-Za-záéíóúÁÉÍÓÚñÑ\s]*$"
                                        (input)="letterOnlyValidator($event)"
                                        required
                                    >
                                    <span *ngIf="f['apellidos']?.errors?.['required']" class="invalid-feedback">
                                        Debe ingresar sus <strong>Apellido</strong>.
                                    </span>
                                    <span *ngIf="f['apellidos']?.errors?.['minlength'] || f['apellidos'].errors?.['invalidName']" class="invalid-feedback">
                                        Apellidos <strong>no válido</strong>.
                                    </span>
                                </div>
                            </div>
                        </div>
    
                        <div class="row">
                            <div class="col-md-12 col-lg-6">
                                <div class="form-group mb-3">
                                    <label for="identificacion">Identificación:</label>
                                    <input 
                                        onlyNumbers
                                        type="text" 
                                        [formControlName]="'identificacion'" 
                                        id="identificacion" 
                                        [ngClass]="{'is-invalid':f['identificacion'].errors && f['identificacion'].touched, 'is-valid':!f['identificacion'].errors && f['identificacion'].touched}" 
                                        class="form-control" 
                                        placeholder="Ingrese su cédula de identificación"
                                        pattern="[- +()0-9]{10}"
                                        (input)="idOnlyValidator($event)"
                                        required
                                    >
                                    <span *ngIf="f['identificacion']?.errors?.['required']" class="invalid-feedback">
                                        Debe ingresar <strong>número de cédula</strong>.
                                    </span>
                                    <span *ngIf="f['identificacion']?.errors?.['pattern'] || f['telefono']?.errors?.['invalidPhoneNumber']" class="invalid-feedback">
                                        Número de cédula <strong>no válido</strong>.
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-12 col-lg-6">
                                <div class="form-group mb-3">
                                    <label for="correo">Correo:</label>
                                    <input 
                                        type="text" 
                                        [formControlName]="'correo'" 
                                        id="correo" 
                                        [ngClass]="{'is-invalid':f['correo'].errors && f['correo'].touched, 'is-valid':!f['correo'].errors && f['correo'].touched}" 
                                        class="form-control" 
                                        placeholder="Ingrese su correo"
                                        required
                                    >
                                    <span *ngIf="f['correo']?.errors?.['required']" class="invalid-feedback">
                                        Debe ingresar <strong>correo electrónico</strong>.
                                    </span>
                                    <span *ngIf="f['correo']?.errors?.['email']" class="invalid-feedback">
                                        Correo electrónico <strong>no válido</strong>.
                                    </span>
                                </div>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-md-12 col-lg-6">
                                <div class="form-group mb-3">
                                    <label for="telefono">Teléfono:</label>
                                    <input
                                        onlyNumbers
                                        type="text" 
                                        [formControlName]="'telefono'" 
                                        id="telefono"
                                        [ngClass]="{'is-invalid':f['telefono'].errors && f['telefono'].touched, 'is-valid':!f['telefono'].errors && f['telefono'].touched}"  
                                        class="form-control" 
                                        placeholder="Ingrese su teléfono" 
                                        pattern="[- +()0-9]{7,12}"
                                        required
                                    >
                                    <span *ngIf="f['telefono']?.errors?.['required']" class="invalid-feedback">
                                        Debe ingresar <strong>número de contacto</strong>.
                                    </span>
                                    <span *ngIf="f['telefono']?.errors?.['pattern'] || f['telefono']?.errors?.['invalidPhoneNumber']" class="invalid-feedback">
                                        Teléfono <strong>no válido</strong>.
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-12 col-lg-6">
                                <div class="form-group mb-3">
                                    <label for="direccion">Dirección:</label>
                                    <input 
                                        type="text" 
                                        [formControlName]="'direccion'" 
                                        id="direccio" 
                                        [ngClass]="{'is-invalid':f['direccion'].errors && f['direccion'].touched, 'is-valid':!f['direccion'].errors && f['direccion'].touched}" 
                                        class="form-control" 
                                        placeholder="Ingrese su dirección" 
                                        uppercase
                                        pattern="^(?!\s*$).+"
                                        required
                                    >
                                    <span *ngIf="f['direccion']?.errors?.['required']" class="invalid-feedback">
                                        Debe ingresar su <strong>Dirección</strong>.
                                    </span>
                                    <span *ngIf="f['direccion'].errors?.['minlength'] || f['direccion'].errors?.['invalidName'] " class="invalid-feedback">
                                        Dirección <strong>no válido</strong>.
                                    </span>
                                </div>
                            </div>
                        </div>
                    
                        <div class="d-flex justify-content-center mt-4">
                            <button 
                                [ladda]="isLoading"
                                data-style="expand-left"
                                data-spinner-color="#202020"
                                type="submit"
                                [disabled]="formFacturacion.invalid || formFacturacion.disabled"
                                class="btn btn-custom-add ladda-button"> <span> Guardar y continuar </span></button>
                        </div>
                                            
                    </form>
                </div>
                <div class="col-md-12 col-lg-6 mt-5">
                    <div class="row">
                        <div class="information">
                            <h4 class="my-3">Resumen del pedido</h4>
                            <span>Detalle del programa:</span>
                            <p><strong>{{ nombrePaquete }}</strong></p>
                            <table class="table table-borderless">
                                <tbody>
                                    <tr>
                                        <td><strong>Precio:</strong></td>
                                        <td>{{ price | number : '1.2-2' }} USD$</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Descuento:</strong></td>
                                        <td>{{ descuento | number : '1.2-2' }} USD$</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Impuestos:</strong></td>
                                        <td>{{ getIva() | number : '1.2-2' }} USD$</td>
                                    </tr>
                                    
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td> <strong>Inversión:</strong></td>
                                        <td>{{ getTotal() | number : '1.2-2' }} USD$</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-lg-6 mt-5">
                    <div class="row">
                        <h5 class="my-3">2.- Método de pago</h5>
                        <h3 class="text-center" *ngIf="formFacturacion.enabled">El pago se realiza con tarjeta de crédito, via PayPhone.</h3>
                        <div id="buttonPago" #buttonPago *ngIf="!formFacturacion.enabled"></div>
                    </div>
                </div>
            </div>

            
        </div>
    </section>

</main>